import { apiClient } from './client';

export type SpellcheckIssue = {
    start: number;
    end: number;
    text: string;
    suggestions: string[];
};

type SpellcheckResponse = {
    data: {
        issues: SpellcheckIssue[];
    };
};

type SpellcheckPayload = {
    report_id?: string;
    section_id?: string;
    text: string;
};

export const spellcheckApi = {
    check: async (
        payload: SpellcheckPayload,
        signal?: AbortSignal,
    ): Promise<SpellcheckResponse> => {
        const response = await apiClient.post<SpellcheckResponse>('/spellcheck/check', payload, {
            signal,
        });

        return response as unknown as SpellcheckResponse;
    },
};
